<!-- Mobile View displays Table in a Stack -->
<div>
  <p-table 
  [value]="viewItems" 
  [columns]="selectedCols" 
  styleClass="p-datatable-striped p-datatable-gridlines p-datatable-sm " 
  datakey="document.Id" 
  [loading]="loading"
  responsiveLayout="stack" 
  [reorderableColumns]="true"
  [rowsPerPageOptions]="[25,50,100]" 
  [(selection)]="tableSelections" 
  selectionMode="multiple"
  scrollHeight="flex"
  >

    <ng-template pTemplate="header" let-columns>
      <tr>
        <th style="text-align: center;">
          <input type="checkbox" aria-label="Select All Checkbox" class="form-check-input" [checked]="allItemsSelected" (change)="toggleAllRows($event)">
        </th>
        <th pTooltip="Properties">
          Properties
        </th >
        <th pTooltip="Locked">
          POF
        </th >      
        <th pTooltip="Accession Number">
          Accession #
        </th>
        <ng-container *ngFor="let col of columns">
          <th *ngIf="col.field !=='AccessionNumber'" pReorderableColumn pResizableColumn pTooltip="{{col.header}}"
            tooltipPosition="top">
            {{col.header}}
          </th>  
        </ng-container>        
      </tr>
    </ng-template>

    <ng-template 
    pTemplate="body" 
    let-rowData
    let-columns="columns">
      <tr>
        <td style="text-align: center;">
          <input type="checkbox" aria-label="Select Item Checkbox" class="form-check-input" [checked]="getRowSelection(rowData)"
            (change)="onRowSelectChange(rowData, $event)">
        </td>
        <td style="text-align: center;">
          <a class="bs-dark toolbar-icon text-primary"
            (click)="showProperties(rowData.document);">
            <i *ngIf="rowData.document.ItemType == 'package'" class="fa fa-box-archive"
              pTooltip="Package Properties" tooltipPosition="left"></i>
            <i *ngIf="rowData.document?.ItemType === 'doc'" class="fa fa-file-lines" 
            pTooltip="Document Properties" tooltipPosition="left"></i>
          </a>
        </td>
        <td style="text-align: center;">
            <i *ngIf="rowData.document.POFStatus === constants.POFLockStatusLocked" class="fa fa-lock"
              pTooltip="Protected Order File - Locked" tooltipPosition="left"></i>  
            <i *ngIf="rowData.document.POFStatus === constants.POFLockStatusUnlocked" class="fa fa-lock-open"
          pTooltip="Protected Order File - Unlocked" tooltipPosition="left"></i>            
        </td>
        <td>
          <a *ngIf="(rowData.document.POFStatus !== constants.POFLockStatusLocked) && (rowData.document.ItemType != 'package')" class="text-primary bs-dark" pTooltip="Click to Download" tooltipPosition="left" 
          (click)="downloadDocument(rowData.document)">
          {{rowData.document?.AccessionNumber}} </a>
          <span *ngIf="(rowData.document.POFStatus === constants.POFLockStatusLocked) || (rowData.document.ItemType == 'package')" pTooltip="Download Not Available">
          {{rowData.document?.AccessionNumber}}</span>
        </td>
        <ng-container *ngFor="let col of columns">
           <td *ngIf="col.field !=='AccessionNumber'"
            pTooltip="{{rowData['document'][col.field]}}" tooltipPosition="top">
            {{rowData['document'][col.field] | addSpaceAfterComma | slice:0:110 }}
          </td>
        </ng-container>
      </tr>
    </ng-template>
  </p-table>
</div>